import { Component, OnInit } from '@angular/core';
import { RoleAccess } from '../../models/role-access.model';
import { UtilService } from '../../service/util.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UserData } from '../../providers/user-data';
import { Storage } from '@ionic/storage';
import { MutasiAntarCounterService } from './mutasi-antar-counter.service';
import { UserProfile } from '../../models/user-profile.model';
import { NavigationExtras, Router } from '@angular/router';
import { AES } from 'crypto-js';
import { environment } from '../../../environments/environment';
import { AfMutasiAntarCounterComponent } from '../../component/advanced-filter/af-mutasi-antar-counter/af-mutasi-antar-counter.component';

@Component({
  selector: 'app-mutasi-antar-counter',
  templateUrl: './mutasi-antar-counter.page.html',
  styleUrls: ['./mutasi-antar-counter.page.scss'],
})
export class MutasiAntarCounterPage implements OnInit {

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };

  rows: any=[];
  keywordSearch: any;
  roleAccess = new RoleAccess();
  userProfile: UserProfile = new UserProfile();
  filteredData: any;
  token: any;
  counterId: any;
  counterIdOrigin: number=0;
  requestStatus: any;
  userAccess: any[] = [];
  roleName: any; 
  docDateStart: any;
  docDateEnd: any;
  filteredRows: any[] = [];
  counterList: any[] = [];
  constructor(
    private mutasiAntarCounterService : MutasiAntarCounterService,
    private utilService : UtilService,
    private toastCtrl : ToastController,
    private navCtrl :NavController,
    private userData: UserData,
    private storage: Storage,
    private router: Router,
    private modalController:ModalController
  ) { }

  ngOnInit() {
    this.filteredRows = this.rows.slice();
  }
  
  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.reloadTable();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  clearFilters() {
    this.keywordSearch = undefined;
    this.counterId = undefined;
    this.counterIdOrigin = undefined;
    this.docDateStart = undefined;
    this.docDateEnd = undefined;
    this.requestStatus = undefined;
    this.pageCallback({ offset: this.page.offset });
  }
   pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      
      let userCounterIds =   this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
      
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "user_counter_id_list": userCounterIds,
        "counter_id": this.counterId,
        "counter_id_origin": this.counterIdOrigin,
        "doc_date_start": this.docDateStart ? this.docDateStart : '2000-01-01',
        "doc_date_end": this.docDateEnd ? this.docDateEnd : '4712-12-31',
        "request_status": this.requestStatus !== undefined ? this.requestStatus : 'null',
        "keywords": this.keywordSearch ? this.keywordSearch : 'null'
      };
      this.mutasiAntarCounterService.getMutationList(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.counterList = response.results.counter_data;
        this.rows = response.results.data;
        this.filteredRows = this.rows.filter(item => 
          userCounterIds.includes(Number(item.counter_id_origin))||
          userCounterIds.includes(Number(item.counter_id_destination))
        );
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }
  goToFormPage(id: any,actionType:any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptAction = AES.encrypt(JSON.stringify(actionType),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptAction
      }
    };
    this.navCtrl.navigateForward(['/mutasi-antar-counter/mutasi-antar-counter-form'], navigationExtras);
  }
  onSearch(keyword: string) {
    const val = keyword.toLowerCase();
    const userCounterIds = this.userProfile.counter_id !== 0 
        ? [this.userProfile.counter_id] 
        : this.userProfile.counter_id_list;

    this.filteredRows = this.rows.filter(row =>
      (userCounterIds.includes(Number(row.counter_id_origin)) ||
       userCounterIds.includes(Number(row.counter_id_destination))) &&
      Object.values(row).some(value =>
        String(value).toLowerCase().includes(val)
      )
    );
  }
   async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: AfMutasiAntarCounterComponent,
      componentProps: {
        counterList: this.counterList,
        counterId: this.counterId,
        counterIdOrigin: this.counterIdOrigin,
        docDateStart: this.docDateStart,
        docDateEnd: this.docDateEnd,
        requestStatus: this.requestStatus
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      let data: any = modelData.data;
      if (data.length > 0) {
        this.keywordSearch = undefined;
        if(data[0].doc_date_start) {
          let convertDateStart = this.utilService.convertDate(data[0].doc_date_start);
          this.docDateStart = convertDateStart.years + '-' + convertDateStart.months + '-' + convertDateStart.dates;
        }
        if(data[0].doc_date_end) {
          let convertDateEnd = this.utilService.convertDate(data[0].doc_date_end);
          this.docDateEnd = convertDateEnd.years + '-' + convertDateEnd.months + '-' + convertDateEnd.dates;
        }
        this.counterId = data[0].counter_id;
        this.counterIdOrigin = parseInt(data[0].counter_id_origin);
        this.requestStatus = data[0].request_status;
        this.pageCallback({ offset: this.page.offset });
      }
    });
    return await modal.present();
  }
}